@if (hasBothChoices) {
  <main class="bathroom-choice-page">
    <section class="choice-hero">
      <img src="assets/img/home/bathroom.jpg" alt="" />
      <div class="choice-hero__overlay"></div>
      <h1>
        <span>Configurer</span> votre futur meuble ou votre salle de bain dans son intégralité
      </h1>
    </section>

    <section
      class="choice-card choice-card--3d"
      role="button"
      tabindex="0"
      (click)="start3d()"
      (keydown.enter)="start3d()"
      (keydown.space)="start3d(); $event.preventDefault()">
      <div class="choice-card__visual">
        <img src="assets/img/placeholders/portal-backgrounds/portal_bathroom.jpg" alt="" />
        <span class="choice-card__badge">3D</span>
      </div>
      <div class="choice-card__content">
        <h2>Concevoir ma salle de bain en 3D</h2>
        <p>
          Créez votre salle de bain sur mesure et explorez-la en 3D. Visualisez l’agencement de votre pièce,
          positionnez les équipements et personnalisez chaque détail.
        </p>
        <button type="button" (click)="start3d(); $event.stopPropagation()">Lancer la configuration</button>
      </div>
    </section>

    <section
      class="choice-card choice-card--2d"
      role="button"
      tabindex="0"
      (click)="start2d()"
      (keydown.enter)="start2d()"
      (keydown.space)="start2d(); $event.preventDefault()">
      <div class="choice-card__visual">
        <img src="assets/img/bathroom/kentia_1.png" alt="" />
        <span class="choice-card__badge">2D</span>
      </div>
      <div class="choice-card__content">
        <h2>Configurer mon meuble en 2D</h2>
        <p>
          Personnalisez votre meuble de salle de bain en toute simplicité grâce à une vue 2D claire et précise.
          Choisissez les dimensions, les rangements, la vasque et les finitions selon vos besoins.
        </p>
        <button type="button" (click)="start2d(); $event.stopPropagation()">Lancer la configuration</button>
      </div>
    </section>
  </main>
}
